import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";
import { Seo } from "@/components/Seo";
import { ACTU_ORDER, ACTU_ARTICLES } from "@/lib/actualitesData";

const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });

export default function ActualitesIndex() {
  return (
    <>
      <Seo
        title="Actualités cybersécurité et informatique pour TPE"
        description="L'actualité de la cybersécurité et de l'informatique des petites entreprises des Hauts-de-France : menaces, conseils pratiques et nouveautés, expliqués simplement."
        path="/actualites"
      />

      <section className="bg-navy grain relative pt-40 pb-20 md:pt-48 md:pb-24 overflow-hidden">
        <div className="relative z-10 mx-auto max-w-4xl px-5 sm:px-8">
          <Reveal>
            <span className="text-xs uppercase tracking-[0.25em] font-medium text-amber-500">Actualités</span>
          </Reveal>
          <Reveal delay={0.05}>
            <h1 className="mt-5 font-display text-5xl sm:text-6xl md:text-7xl font-bold tracking-tighter text-white text-balance">
              Ce qu'il faut savoir, quand il faut le savoir.
            </h1>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-lg md:text-xl text-slate-300 max-w-xl leading-relaxed">
              Menaces du moment, conseils pratiques et nouveautés — pour garder une longueur
              d'avance sur les risques qui visent les petites entreprises.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-white py-20 md:py-28">
        <div className="mx-auto max-w-4xl px-5 sm:px-8 space-y-px">
          {ACTU_ORDER.map((slug, i) => {
            const article = ACTU_ARTICLES[slug];
            if (!article) return null;
            return (
              <Reveal key={slug} delay={i * 0.05}>
                <Link
                  to={`/actualites/${slug}`}
                  className="group flex items-center justify-between gap-6 py-8 border-t border-slate-200 last:border-b hover:bg-slate-50 -mx-5 px-5 sm:-mx-8 sm:px-8 transition-colors"
                  data-testid={`actu-index-link-${slug}`}
                >
                  <div>
                    <div className="flex items-center gap-3 text-xs uppercase tracking-[0.25em] font-medium text-amber-600">
                      <span>{article.eyebrow}</span>
                      <span className="text-slate-300">•</span>
                      <time dateTime={article.date} className="text-slate-400 tracking-normal normal-case">
                        {formatDate(article.date)}
                      </time>
                    </div>
                    <h2 className="mt-2 font-display text-xl sm:text-2xl font-semibold tracking-tight text-navy">{article.title}</h2>
                    <p className="mt-2 text-slate-600 leading-relaxed max-w-2xl">{article.excerpt}</p>
                  </div>
                  <ArrowRight className="w-6 h-6 text-slate-300 group-hover:text-amber-500 group-hover:translate-x-1 transition-all shrink-0" />
                </Link>
              </Reveal>
            );
          })}
        </div>
      </section>
    </>
  );
}
